var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V6.55C16 5.56991 16 5.07986 15.8093 4.70552C15.6415 4.37623 15.3738 4.10852 15.0445 3.94074C14.6701 3.75 14.1801 3.75 13.2 3.75H6.55C5.56991 3.75 5.07986 3.75 4.70552 3.94074C4.37623 4.10852 4.10852 4.37623 3.94074 4.70552C3.75 5.07986 3.75 5.56991 3.75 6.55V13.2C3.75 14.1801 3.75 14.6701 3.94074 15.0445C4.10852 15.3738 4.37623 15.6415 4.70552 15.8093C5.07986 16 5.56991 16 6.55 16H9M11.8 21.25H18.45C19.4301 21.25 19.9201 21.25 20.2945 21.0593C20.6238 20.8915 20.8915 20.6238 21.0593 20.2945C21.25 19.9201 21.25 19.4301 21.25 18.45V11.8C21.25 10.8199 21.25 10.3299 21.0593 9.95552C20.8915 9.62623 20.6238 9.35852 20.2945 9.19074C19.9201 9 19.4301 9 18.45 9H11.8C10.8199 9 10.3299 9 9.95552 9.19074C9.62623 9.35852 9.35852 9.62623 9.19074 9.95552C9 10.3299 9 10.8199 9 11.8V18.45C9 19.4301 9 19.9201 9.19074 20.2945C9.35852 20.6238 9.62623 20.8915 9.95552 21.0593C10.3299 21.25 10.8199 21.25 11.8 21.25Z",
    stroke: "#DF320C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 15.25H18.375",
    stroke: "#DF320C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12.125L15.25 18.375",
    stroke: "#DF320C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.c5f0b6028c933b6df5136e686de4753d.svg";
export { ForwardRef as ReactComponent };